import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import countries from '../Components/Images/countries2.png'
import { RiArrowRightSLine } from 'react-icons/ri';
import HomeNavBar from '../Components/HomeNavBar'
import newLogo from '../Components/Images/newLogo.png'
import bg from '../Components/Images/bg2.png'
import Logo from '../Components/Images/reccur logo.svg'
import { MdMenu } from 'react-icons/md';
import { RiArrowRightDoubleFill } from "react-icons/ri";
import { GoDotFill } from "react-icons/go";
import a from '../Components/Images/1.png';
import b from '../Components/Images/2.png';
import c from '../Components/Images/3.png';
import d from '../Components/Images/4.png';
import e from '../Components/Images/5.png';
import f from '../Components/Images/6.png';
import g from '../Components/Images/7.png';
import h from '../Components/Images/8.png';
import i from '../Components/Images/9.png';
import j from '../Components/Images/10.png';
import k from '../Components/Images/11.png';
import l from '../Components/Images/12.png';
import m from '../Components/Images/13.png';
import n from '../Components/Images/14.png';
import o from '../Components/Images/15.png';
import FAQ2 from '../Components/FAQ2';
import Footer from '../Components/Footer';

const UseCases = () => {

    const [openMenu, setOpenMenu] = useState(false)
    const location = useLocation()

    return (
        <div className='3xl:text-2xl mk:text-lg sd:text-[17px] text-[14px]'>
            <div className='sd:m-10'>
                <div
                    className="relative w-full rounded-[20px] bg-[#E8E1F5]"
                    style={{
                        backgroundImage: `url(${bg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: '#E8E1F5'
                    }}
                >
                    <div className='relative w-full top-0 rounded-[20px] z-50 text-black sd:px-12 px-2 sd:py-12 py-4 pb-16'>
                        <div className='relative'>
                            <div className='flex justify-between items-center px-2'>
                                <a href="/">
                                    <div className='flex gap-2 items-center'>
                                        <img src={Logo} className='mk:w-auto w-5' alt="" />
                                        <p className='font-medium'>reccur</p>
                                    </div>
                                </a>
                                <div className='lg:flex hidden gap-8 ml-24'>
                                    <a href="/use_cases">
                                        <p className={`${location.pathname === '/use_cases' && 'font-bold'}`}>Use cases</p>
                                    </a>
                                    <a href="/how_it_works">
                                        <p className={`${location.pathname === '/how_it_works' && 'font-bold'}`}>How it Works</p>
                                    </a>
                                    <a href="/about">
                                        <p className={`${location.pathname === '/about' && 'font-bold'}`}>About</p>
                                    </a>
                                </div>
                                <div className='lg:flex hidden'>
                                    <a href="/login">
                                        <button className='py-2 px-[14px]'>Log in</button>
                                    </a>
                                    <a href="/signup">
                                        <button className='bg-[#531CB3] font-light text-white py-2 px-[14px] rounded-[10px]'>
                                            Get started
                                        </button>
                                    </a>
                                </div>
                                <MdMenu onClick={() => setOpenMenu(!openMenu)} className='lg:hidden cursor-pointer sh:text-[30px] text-xl' />
                            </div>

                            <div className='flex lg:flex-row flex-col justify-between gap-6 w-full sd:mt-20 mt-5 lg:items-start items-center'>
                                <div className='w-full flex flex-col items-center gap-6'>
                                    <img className='sd:size-32 size-24' src={newLogo} alt="" />
                                    <p className='font-semibold 3xl:text-5xl text-center text-4xl'>Who Reccur Serves - at a glance</p>
                                    <div>
                                        <div className='flex mh:flex-row flex-col items-center gap-3'>
                                            <div className='flex gap-3 items-center text-[#828185]'>
                                                <p className='text-[#525154] text-center font-normal'>Earn (or move) hard currency</p>
                                                <RiArrowRightDoubleFill className='text-xl' />
                                            </div>
                                            <div className='flex gap-3 items-center text-[#828185]'>
                                                <p className='text-[#525154] text-center font-normal'>Keep it in stable-value USDC</p>
                                                <RiArrowRightDoubleFill className='text-xl' />
                                            </div>
                                        </div>
                                        <p className='text-[#525154] mt-3 text-center font-normal'>Cash out or pay anyone in minutes.</p>
                                    </div>
                                    <a href="/signup">
                                        <button className='bg-[#531CB3] text-white flex gap-2 items-center justify-center sh:py-[14px] py-[9px] px-[24px] shadow-md shadow-[#531CB3] rounded-lg'>
                                            Get started
                                            <RiArrowRightSLine className='size-7' />
                                        </button>
                                    </a>
                                    <div className='flex items-center gap-0'>
                                        <img className='3xl:w-36 sd:w-28 w-[70px]' src={countries} alt="" />
                                        <p className='text-[#525154] font-normal'>Open a bank account in 30+ countries.</p>
                                    </div>
                                    <div className='flex items-center flex-wrap justify-center mh:gap-3 gap-2'>
                                        <a href="#freelance">
                                            <div className='flex items-center text-xs sd:text-[17px] gap-3 bg-white rounded-full mh:p-4 p-2 font-normal text-[#525154]'>
                                                <GoDotFill className='text-[#531CB3] text-lg' />
                                                <p>Freelancers</p>
                                            </div>
                                        </a>

                                        <a href="#entrepreneurs">
                                            <div className='flex items-center gap-3 text-xs sd:text-[17px] bg-white rounded-full mh:p-4 p-2 font-normal text-[#525154]'>
                                                <GoDotFill className='text-[#531CB3] text-lg' />
                                                <p>Creative Entrepreneurs</p>
                                            </div>
                                        </a>

                                        <a href="#teams">
                                            <div className='flex items-center gap-3 text-xs sd:text-[17px] bg-white rounded-full mh:p-4 p-2 font-normal text-[#525154]'>
                                                <GoDotFill className='text-[#531CB3] text-lg' />
                                                <p>Remote Teams</p>
                                            </div>
                                        </a>

                                        <a href="#importers">
                                            <div className='flex items-center gap-3 text-xs sd:text-[17px] bg-white rounded-full mh:p-4 p-2 font-normal text-[#525154]'>
                                                <GoDotFill className='text-[#531CB3] text-lg' />
                                                <p>Importers & Side Hustlers</p>
                                            </div>
                                        </a>

                                        <a href="#saves">
                                            <div className='flex items-center gap-3 text-xs sd:text-[17px] bg-white rounded-full mh:p-4 p-2 font-normal text-[#525154]'>
                                                <GoDotFill className='text-[#531CB3] text-lg' />
                                                <p>Crypto-Native Savers</p>
                                            </div>
                                        </a>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <HomeNavBar openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </div>
                </div>
            </div>
            <div>
                <div id='freelance' className='bg-[#ffffff] sm:py-[100px] py-10 md:px-16 px-5 gap-16 flex flex-col'>
                    <div className='flex justify-between sm:px-20'>
                        <div>
                            <p className='cursor-pointer font-semibold uppercase text-[#000000]'>for the FREELANCERS</p>
                            <p className='mk:text-[50px] sd:text-[30px] text-[24px] font-thin mc:leading-6 mk:mt-6 text-[#302F33]'>Making money online?</p>
                            <p className='mk:text-[50px] sd:text-[30px] text-[24px] font-semibold mk:mt-8 text-[#000000]'>Make getting paid easier.</p>
                        </div>
                    </div>
                    <div className='flex flex-wrap mc:grid-cols-3 sd:mt-5 sm:grid-cols-2 md:px-9 sm:px-5 gap-4 justify-center'>
                        <img src={a} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={b} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={c} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                    </div>
                </div>
            </div>
            <div>
                <div id='entrepreneurs' className='bg-[#FEEDED] sm:py-[100px] py-10 md:px-16 px-5 gap-16 flex flex-col'>
                    <div className='flex justify-between sm:px-20'>
                        <div>
                            <p className='cursor-pointer font-semibold uppercase text-[#DC2626]'>For the Creative Entrepreneurs</p>
                            <p className='mk:text-[50px] sd:text-[30px] text-[24px] font-thin mc:leading-6 mk:mt-6 text-[#302F33]'>Keep your earnings in check</p>
                            <p className='mk:text-[50px] sd:text-[30px] text-[24px] font-semibold mk:mt-8 text-[#DC2626]'>While focusing on what you do best</p>
                        </div>
                    </div>
                    <div className='flex flex-wrap mc:grid-cols-3 sd:mt-5 sm:grid-cols-2 md:px-9 sm:px-5 gap-4 justify-center'>
                        <img src={d} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={e} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={f} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                    </div>
                </div>
            </div>
            <div>
                <div id='teams' className='bg-[#E8E1F5] sm:py-[100px] py-10 md:px-16 px-5 gap-16 flex flex-col'>
                    <div className='flex justify-between sm:px-20'>
                        <div>
                            <p className='cursor-pointer font-semibold uppercase text-[#431594]'>For Micro-Agencies & Remote Teams</p>
                            <p className='mk:text-[50px] sd:text-[30px] text-[24px] font-thin mc:leading-6 mk:mt-6 text-[#302F33]'>Get paid and pay your team effortlessly</p>
                            <p className='mk:text-[50px] sd:text-[30px] text-[24px] font-semibold mk:mt-8 text-[#431594]'>No matter where they are in the world.</p>
                        </div>
                    </div>
                    <div className='flex flex-wrap mc:grid-cols-3 sd:mt-5 sm:grid-cols-2 md:px-9 sm:px-5 gap-4 justify-center'>
                        <img src={g} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={h} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={i} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                    </div>
                </div>
            </div>
            <div>
                <div id='importers' className='bg-[#ffffff] sm:py-[100px] py-10 md:px-16 px-5 gap-16 flex flex-col'>
                    <div className='flex justify-between sm:px-20'>
                        <div>
                            <p className='cursor-pointer font-semibold uppercase text-[#000000]'>for Importers & Side Hustlers</p>
                            <p className='mk:text-[50px] sd:text-[30px] text-[24px] font-thin mc:leading-6 mk:mt-6 text-[#302F33]'>Handling imports or exports?</p>
                            <p className='mk:text-[50px] sd:text-[30px] text-[24px] font-semibold mk:mt-8 text-[#000000]'>Send and receive payments in a snap</p>
                        </div>
                    </div>
                    <div className='flex flex-wrap mc:grid-cols-3 sd:mt-5 sm:grid-cols-2 md:px-9 sm:px-5 gap-4 justify-center'>
                        <img src={j} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={k} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={l} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                    </div>
                </div>
            </div>
            <div>
                <div id='saves' className='bg-[#E8E1F5] sm:py-[100px] py-10 md:px-16 px-5 gap-16 flex flex-col'>
                    <div className='flex justify-between sm:px-20'>
                        <div>
                            <p className='cursor-pointer font-semibold uppercase text-[#431594]'>for the Crypto Fam</p>
                            <p className='mk:text-[50px] text-[30px] font-thin mc:leading-6 mk:mt-6 text-[#302F33]'>Already living that crypto life?</p>
                            <p className='mk:text-[50px] text-[30px] font-semibold mk:mt-8 text-[#431594]'>This one’s for you.</p>
                        </div>
                    </div>
                    <div className='flex flex-wrap mc:grid-cols-3 sd:mt-5 sm:grid-cols-2 md:px-9 sm:px-5 gap-4 justify-center'>
                        <img src={m} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={n} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                        <img src={o} className='3xl:w-[500px] sm:w-[400px]' alt="" />
                    </div>
                </div>
            </div>
            <FAQ2 />
            <Footer />
        </div>
    )
}

export default UseCases